import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { shareAPI } from '../services/api';

const ShareRedirect = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleShare = async () => {
      try {
        const response = await shareAPI.getShareLinkByToken(token);
        
        if (response.success) {
          navigate(`/download?ref=${token}`, { 
            state: { shareData: response.data } 
          });
        }
      } catch (err) {
        setError(err.message || 'Share link not found');
        setLoading(false);
      }
    };

    if (token) {
      handleShare();
    }
  }, [token, navigate]);

  if (loading) {
    return (
      <div className="bg-[#0a0a0a] text-white min-h-screen pt-16 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400">Loading shared link...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-[#0a0a0a] text-white min-h-screen pt-16 flex items-center justify-center">
        <div className="text-center max-w-md">
          <div className="text-6xl mb-6">🔗</div>
          <h1 className="text-3xl font-black mb-4">Link Not Found</h1>
          <p className="text-gray-400 mb-8">{error}</p>
          <a
            href="/download"
            className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-400 text-black font-bold px-8 py-4 rounded-xl transition-all"
          >
            Go to Download Page
          </a>
        </div>
      </div>
    );
  }

  return null;
};

export default ShareRedirect;
